import './styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

import React, { useEffect, useRef, useState } from 'react';

type Prop = {
    isOpen: boolean;
    onClose: () => void;
    children: JSX.Element;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    iframeRef: React.MutableRefObject<any>;
};

const Modal = ({ isOpen, onClose, children, iframeRef }: Prop) => {
    const [isModalOpen, setModalOpen] = useState(isOpen);
    const modalRef = useRef(null);

    const handleCloseModal = () => {
        try {
            const videoSrc = iframeRef.current.src ?? null;
            iframeRef.current.src = videoSrc;
        } catch (error) {
            console.log('error trying to stop video');
        }

        if (onClose) {
            onClose();
        }

        setModalOpen(false);
    };

    const handleKeyDown = (event: { key: string }) => {
        if (event.key === 'Escape') {
            handleCloseModal();
        }
    };

    useEffect(() => {
        setModalOpen(isOpen);
    }, [isOpen]);

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const modalElement = modalRef.current as any;

        if (modalElement) {
            if (isModalOpen) {
                modalElement.showModal();
            } else {
                modalElement.close();
            }
        }
    }, [isModalOpen]);

    return (
        <dialog ref={modalRef} onKeyDown={handleKeyDown} className="modal">
            <div>
                <button className="modal-close-btn" onClick={handleCloseModal}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
            <div className="modal-body">{children}</div>
        </dialog>
    );
};

export default Modal;
